import {defineStore} from 'pinia'
import {getPageContent} from '~/api/content'

export const useShippingTypesStore = defineStore('shipping-types', () => {
  const shippingTypesContent = ref()

  const shippingTypesItems = computed((): { id: string, title: string, icon: { url?: string, name?: string }, links: PublicInfoGridItem[] }[] => [
    {
      id: 'size',
      title: shippingTypesContent.value?.blocks?.size?.title,
      icon: { url: '/svg/vz-size-box.svg' },
      links: [
        { 
          link: {
            to: { name: 'shippingtypes-oversized' },
          },
          title: shippingTypesContent.value?.blocks?.size.oversizedTitle,
          text: shippingTypesContent.value?.blocks?.size.oversizedText,
        },
        {
          link: {
            to: { name: 'shippingtypes-smallcargo'},
          },
          title: shippingTypesContent.value?.blocks?.size.smallTitle,
          text: shippingTypesContent.value?.blocks?.size.smallText,
        },
      ]
    },
    {
      id: 'type',
      title: shippingTypesContent.value?.blocks?.type?.title,
      icon: { name: 'cart' },
      links: [
        {
          link: {
            to: { name: 'shippingtypes-personalitemstransportation'},
          },
          title: shippingTypesContent.value?.blocks?.type.personalTitle,
          text: shippingTypesContent.value?.blocks?.type.personalText,
        },
        {
          link: {
            to: { name: 'shippingtypes-metal'},
          },
          title: shippingTypesContent.value?.blocks?.type.metalTitle,
          text: shippingTypesContent.value?.blocks?.type.metalText,
        },
        {
          link: {
            to: { name: 'shippingtypes-fragile'},
          },
          title: shippingTypesContent.value?.blocks?.type.fragileTitle,
          text: shippingTypesContent.value?.blocks?.type.fragileText,
        },
        {
          link: {
            to: { name: 'shippingtypes-goods'},
          },
          title: shippingTypesContent.value?.blocks?.type.goodsTitle,
          text: shippingTypesContent.value?.blocks?.type.goodsText,
        },
        {
          link: {
            to: { name: 'shippingtypes-furniture'},
          },
          title: shippingTypesContent.value?.blocks?.type.furnitureTitle,
          text: shippingTypesContent.value?.blocks?.type.furnitureText,
        },
        {
          link: {
            to: { name: 'shippingtypes-auto-parts'},
          },
          title: shippingTypesContent.value?.blocks?.type.autoPartsTitle,
          text: shippingTypesContent.value?.blocks?.type.autoPartsText,
        },
        {
          link: {
            to: { name: 'shippingtypes-industrial-equipment'},
          },
          title: shippingTypesContent.value?.blocks?.type.industrialEquipmentTitle,
          text: shippingTypesContent.value?.blocks?.type.industrialEquipmentText,
        },
        {
          link: {
            to: { name: 'shippingtypes-consumer-goods'},
          },
          title: shippingTypesContent.value?.blocks?.type.consumerGoodsTitle,
          text: shippingTypesContent.value?.blocks?.type.consumerGoodsText,
        },
        {
          link: {
            to: { name: 'shippingtypes-medical-devices'},
          },
          title: shippingTypesContent.value?.blocks?.type.medicalDevicesTitle,
          text: shippingTypesContent.value?.blocks?.type.medicalDevicesText,
        },
      ]
    },
    {
      id: 'hardware',
      title: shippingTypesContent.value?.blocks?.hardware?.title,
      icon: { url: '/svg/vz-gear.svg' },
      links: [
        {
          link: {
            to: { name: 'shippingtypes-motorcycletransportation' },
          },
          title: shippingTypesContent.value?.blocks?.hardware.motoTitle,
          text: shippingTypesContent.value?.blocks?.hardware.motoText,
        },
        {
          link: {
            to: { name: 'shippingtypes-refrigerator'},
          },
          title: shippingTypesContent.value?.blocks?.hardware.refrigeratorTitle,
          text: shippingTypesContent.value?.blocks?.hardware.refrigeratorText,
        },
        {
          link: {
            to: { name: 'shippingtypes-bench'},
          },
          title: shippingTypesContent.value?.blocks?.hardware.benchTitle,
          text: shippingTypesContent.value?.blocks?.hardware.benchText,
        },
        {
          link: {
            to: { name: 'shippingtypes-boat'},
          },
          title: shippingTypesContent.value?.blocks?.hardware.boatTitle,
          text: shippingTypesContent.value?.blocks?.hardware.boatText,
        },
        {
          link: {
            to: { name: 'shippingtypes-snowmobile'},
          },
          title: shippingTypesContent.value?.blocks?.hardware.snowmobileTitle,
          text: shippingTypesContent.value?.blocks?.hardware.snowmobileText,
        },
        {
          link: {
            to: { name: 'shippingtypes-quad-bike'},
          },
          title: shippingTypesContent.value?.blocks?.hardware.quadBikeTitle,
          text: shippingTypesContent.value?.blocks?.hardware.quadBikeText,
        },
        {
          link: {
            to: { name: 'shippingtypes-special-equipment'},
          },
          title: shippingTypesContent.value?.blocks?.hardware.specialEquipmentTitle,
          text: shippingTypesContent.value?.blocks?.hardware.specialEquipmentText,
        },
        {
          link: {
            to: { name: 'shippingtypes-tools'},
          },
          title: shippingTypesContent.value?.blocks?.hardware.toolsTitle,
          text: shippingTypesContent.value?.blocks?.hardware.toolsText,
        },
      ]
    },
    {
      id: 'other',
      title: shippingTypesContent.value?.blocks?.other?.title,
      icon: { url: '/svg/vz-armchair.svg' },
      links: [
        {
          link: {
            to: { name: 'shippingtypes-wheels'},
          },
          title: shippingTypesContent.value?.blocks?.other.wheelsTitle,
          text: shippingTypesContent.value?.blocks?.other.wheelsText,
        },
        {
          link: {
            to: { name: 'shippingtypes-chair'},
          },
          title: shippingTypesContent.value?.blocks?.other.chairTitle,
          text: shippingTypesContent.value?.blocks?.other.chairText,
        },
        {
          link: {
            to: { name: 'shippingtypes-trailer'},
          },
          title: shippingTypesContent.value?.blocks?.other.trailerTitle,
          text: shippingTypesContent.value?.blocks?.other.trailerText,
        },
        {
          link: {
            to: { name: 'shippingtypes-engine'},
          },
          title: shippingTypesContent.value?.blocks?.other.engineTitle,
          text: shippingTypesContent.value?.blocks?.other.engineText,
        },
        {
          link: {
            to: { name: 'shippingtypes-barrels'},
          },
          title: shippingTypesContent.value?.blocks?.other.barrelsTitle,
          text: shippingTypesContent.value?.blocks?.other.barrelsText,
        },
        {
          link: {
            to: { name: 'shippingtypes-lumber'},
          },
          title: shippingTypesContent.value?.blocks?.other.lumberTitle,
          text: shippingTypesContent.value?.blocks?.other.lumberText,
        },
        {
          link: {
            to: { name: 'shippingtypes-pipes'},
          },
          title: shippingTypesContent.value?.blocks?.other.pipesTitle,
          text: shippingTypesContent.value?.blocks?.other.pipesText,
        },
        {
          link: {
            to: { name: 'shippingtypes-sofa'},
          },
          title: shippingTypesContent.value?.blocks?.other.sofaTitle,
          text: shippingTypesContent.value?.blocks?.other.sofaText,
        },
        {
          link: {
            to: { name: 'shippingtypes-musical-instruments'},
          },
          title: shippingTypesContent.value?.blocks?.other.musicTitle,
          text: shippingTypesContent.value?.blocks?.other.musicText,
        },
        {
          link: {
            to: { name: 'shippingtypes-piano'},
          },
          title: shippingTypesContent.value?.blocks?.other.pianoTitle,
          text: shippingTypesContent.value?.blocks?.other.pianoText,
        },
        {
          link: {
            to: { name: 'shippingtypes-cable'},
          },
          title: shippingTypesContent.value?.blocks?.other.cableTitle,
          text: shippingTypesContent.value?.blocks?.other.cableText,
        },
        {
          link: {
            to: { name: 'shippingtypes-newspapers'},
          },
          title: shippingTypesContent.value?.blocks?.other.newspapersTitle,
          text: shippingTypesContent.value?.blocks?.other.newspapersText,
        },
        {
          link: {
            to: { name: 'shippingtypes-clothes'},
          },
          title: shippingTypesContent.value?.blocks?.other.clothesTitle,
          text: shippingTypesContent.value?.blocks?.other.clothesText,
        },
        {
          link: {
            to: { name: 'shippingtypes-building-materials'},
          },
          title: shippingTypesContent.value?.blocks?.other.buildingMaterialsTitle, 
          text: shippingTypesContent.value?.blocks?.other.buildingMaterialsText,
        },
        {
          link: {
            to: { name: 'shippingtypes-books'},
          },
          title: shippingTypesContent.value?.blocks?.other.booksTitle,
          text: shippingTypesContent.value?.blocks?.other.booksText,
        },
        {
          link: {
            to: { name: 'shippingtypes-dishes'},
          },
          title: shippingTypesContent.value?.blocks?.other.dishesTitle,
          text: shippingTypesContent.value?.blocks?.other.dishesText,
        },
      ]
    }
  ])

  const terminalsShippingTypesItems = computed(() => {
    return !shippingTypesContent.value
      ? []
      : [
          { 
            link: { to: { name: 'shippingtypes-personalitemstransportation'} },
            title: 'Перевозка вещей',
            text: shippingTypesContent.value?.blocks?.type.personalText
          }, 
          { 
            link: { to: { name: 'shippingtypes-furniture' } }, 
            title: 'Перевозка мебели',
            text: shippingTypesContent.value?.blocks?.type.furnitureText
          },
          { 
            link: { to: { name: 'shippingtypes-motorcycletransportation' } }, 
            title: 'Перевозка мотоцикла',
            text: shippingTypesContent.value?.blocks?.hardware.motoText
          
          }, 
          { 
            link: { to: { name: 'shippingtypes-special-equipment' } }, 
            title: 'Перевозка спецтехники',
            text: shippingTypesContent.value?.blocks?.hardware.specialEquipmentText,
          },
          { 
            link: { to: { name: 'shippingtypes-wheels' } }, 
            title: 'Перевозка дисков и шин',
            text: shippingTypesContent.value?.blocks?.other.wheelsText,
          },
          { 
            link: { to: { name: 'shippingtypes-building-materials' } }, 
            title: 'Перевозка строительных материалов',
            text: shippingTypesContent.value?.blocks?.other.buildingMaterialsText,
          }
        ]
  })

  // Возвращает предыдущий и следующий по списку вид груза
  async function getShippingTypesChainItems(value: string) {
    let data = [] as PublicHelpItem & { title: string }[]
    await initializeShippingTypes()

    shippingTypesItems.value.forEach(item => {
      data = [...data, ...item.links]
    })

    const i = data.findIndex(item => item.link.to.name === `shippingtypes-${value}`)
    const prev = value === 'oversized' 
      ? data.find(item => item.link.to.name === 'shippingtypes-fragile')
      : (data[i - 1] || data[data.length - 1]) 
    const next = data[i + 1] || data[0]
    return [prev, next]
  }

  async function initializeShippingTypes() {
    if (!shippingTypesContent.value?.length) {
      shippingTypesContent.value = await getPageContent('/shippingtypes')
    }
  }

  initializeShippingTypes()

  return {
    shippingTypesContent,
    shippingTypesItems,
    terminalsShippingTypesItems,
    getShippingTypesChainItems
  }
})
